<template><IndustrialPropertyFormEditor form-name="modifyIndustrialPropertyForm" modification /></template>
<script>
import IndustrialPropertyFormEditor from "./IndustrialPropertyFormEditor.vue";
export default { name: "ModifyIndustrialPropertyForm", components: { IndustrialPropertyFormEditor } };
</script>
